<div class="header-wrapper" [class.home]="isHome()">
  <div class="avatar" *ngIf="isHome()">
    <img
      class="logo"
      [src]="clientAvatarSrc"
      [alt]="userData?.org_id"
      (error)="setDefault()"
    />
    <div class="options" (click)="toggleMenu()"></div>
  </div>
  <app-user-dialog
    [data]="userData"
    [avatar]="isHome() ? clientAvatarSrc : defaultAvatarSrc"
    *ngIf="showMenu"
  >
  </app-user-dialog>
  <div
    class="button user rounded generic-tooltip right"
    *ngIf="!isHome()"
    [attr.data-tooltip]="'User' | translate"
    (click)="toggleMenu()"
  >
    {{ 'User' | translate }}
  </div>
  <div style="flex-grow: 1" *ngIf="isHome()"></div>
  <div class="navigator-wrapper" [class.only-bottom]="isHome()">
    <nav *ngIf="!isHome()">
      <a
        [routerLinkActive]="['']"
        [ngClass]="rla.isActive ? 'selected' : ''"
        [class.selected]="rla.isActive ? true : isMapSelected()"
        #rla="routerLinkActive"
        [routerLink]="['/' + verticalSlug + '/map']"
        [attr.data-tooltip]="'Map' | translate"
        class="grid generic-tooltip right"
        *ngIf="canShowMap()"
      ></a>
      <a
        routerLinkActive="selected"
        routerLink="/{{ verticalSlug }}/campaigns"
        [attr.data-tooltip]="'Campaigns' | translate"
        class="campaigns generic-tooltip right"
        *ngIf="canShowCampaigns()"
      ></a>

      <a
        routerLinkActive="selected"
        routerLink="/{{ verticalSlug }}/national"
        [attr.data-tooltip]="'National' | translate"
        class="national generic-tooltip right"
        *ngIf="canShowOD()"
      ></a>

      <a
        routerLinkActive="selected"
        routerLink="/{{ verticalSlug }}/international"
        [attr.data-tooltip]="'International' | translate"
        class="international generic-tooltip right"
        *ngIf="canShowOD()"
      ></a>
      <a
        routerLinkActive="selected"
        routerLink="/{{ verticalSlug }}/intracity"
        [attr.data-tooltip]="'Intracity' | translate"
        class="intracity generic-tooltip right"
        *ngIf="canShowOD()"
      ></a>

      <a
        routerLinkActive="selected"
        routerLink="/{{ verticalSlug }}/insights"
        [attr.data-tooltip]="'Auto-insights' | translate"
        class="insights generic-tooltip right"
        [class.disabled]="!hasAggregates"
        *ngIf="canShowInsights()"
      ></a>
      <a
        routerLinkActive="selected"
        routerLink="/{{ verticalSlug }}/historical"
        [attr.data-tooltip]="'Historical' | translate"
        class="historical generic-tooltip right"
        [class.disabled]="!hasAggregates"
        *ngIf="canShowCharts()"
      ></a>
      <!-- <a routerLinkActive="selected" routerLink="/{{verticalSlug}}/twin-areas"
      [attr.data-tooltip]="'Twin Areas' | translate" class="twinareas generic-tooltip right"
      [class.disabled]="!poi"
      *ngIf="canShowTwinAreas()"></a> -->
    </nav>
    <div class="bottom">
      <img
        *ngIf="politisLogos && !isHome()"
        class="logo-gooh"
        src="/assets/img/brands/politis/logo-gooh-blue.svg"
      />
      <span *ngIf="!politisLogos" class="vertical-name">{{
        verticalName | translate
      }}</span>
      <a
        class="button fullscreen rounded generic-tooltip right"
        [class.exit]="fullscreenActive"
        (click)="toggleFullscreen()"
        [attr.data-tooltip]="'Fullscreen' | translate"
      >
        {{ 'Fullscreen' | translate }}
      </a>
    </div>
  </div>
  <img *ngIf="!politisLogos" class="logo bottom" [src]="defaultLogoSrc" />
</div>
